'use strict';

import angular from 'angular';

export default function($parse, $uibModal) {
	'ngInject';

	return {
		link: postLink,
		scope: {
			$templateUrl: '<templateUrl',
			$context: '<context',
		},
	};

	function postLink(scope, element, attrs) {
		element.on('click', () => {
			$uibModal.open({
				templateUrl: scope.$templateUrl,
				scope,
			}).result.then((modalResult) => {
				if (attrs.onSuccess) {
					$parse(attrs.onSuccess)(scope, {result: modalResult});
				}
			})
		});
	}
}
